import { BordOneToneIcon, NudosMaskedNumberInput } from 'components/NudosComponents';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { ILogisticServiceEditionForm } from '../../LogisticServiceEdition.types';
import { CLIENT_PLAN_SUBSCRIPTIONS } from 'types/client.types';
import { VOLATILE_CURRENCIES } from 'utils/logisticServices.utils';
import { CURRENCIES } from 'types/bussines';
import { formatCost } from 'utils/formatNumbers';

import './LSEditionHeader.scss';

interface IEditLSHeaderProps {
  companyName?: string;
  logisticServiceId?: number;
  exchangeRate?: number;
  currency?: string;
}

const LSEditionHeader = ({ companyName, logisticServiceId, exchangeRate, currency }: IEditLSHeaderProps) => {
  const { control } = useFormContext<ILogisticServiceEditionForm>();
  const levelSubscription = useWatch({ control, name: 'levelSubscription' });
  const isCurrencyUSD = currency === CURRENCIES.USD;
  const isVolatileCurrency = VOLATILE_CURRENCIES.includes(currency as CURRENCIES);

  return (
    <section className="LSEditionHeader">
      <div className="infoContainer">
        <div className="iconContainer">
          <BordOneToneIcon variant="dollarSign2" customWidth="20px" stroke={'white'} standardSize={20} />
        </div>
        <div className="LSinfo">
          <p className="LSinfoTitle">Edición del resumen del servicio</p>
          <p className="LSinfoText">
            <b>{companyName}</b>
            {levelSubscription && ` (${CLIENT_PLAN_SUBSCRIPTIONS[levelSubscription]}) `}
            <b>- SL N°{logisticServiceId}</b>
          </p>
        </div>
      </div>
      {!isCurrencyUSD && (
        <div className="exchangeRate">
          Tasa de cambio:{' '}
          {isVolatileCurrency ? (
            <Controller
              name="exchangeRate"
              control={control}
              render={({ field }) => (
                <NudosMaskedNumberInput
                  isFilled
                  placeholder={`${exchangeRate ? exchangeRate : '0.00'} ${currency}`}
                  handleChange={evt => field.onChange(evt as string)}
                  currentValue={String(field.value)}
                  maskPrefix="$"
                  maskSufix={currency}
                  numberOfDecimals={2}
                />
              )}
            />
          ) : (
            <span>
              {exchangeRate ? formatCost(Number(exchangeRate)) : '0.00'} {currency}
            </span>
          )}
        </div>
      )}
    </section>
  );
};

export default LSEditionHeader;
